import { RETAIL_STOCK_PERMISSION } from '@fielded/fs-api/lib/user/tools'

// Takes user object from 'withUser' HOC
const hasRetailStock = ({ roles = [] }) => {
  return roles.includes(`feature:${RETAIL_STOCK_PERMISSION}`)
}

export { hasRetailStock }
